"use strict";
var FieldRules = (function () {
    function FieldRules() {
    }
    return FieldRules;
}());
exports.FieldRules = FieldRules;
//# sourceMappingURL=D:/a/1/s/eligibility/src/rules/models/field-rules.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/eligibility/src/rules/models/field-rules.model.js